export enum Activity {
  Downgrade,
  Upgrade,
  FirstScore,
  Affirmation,
  None,
  Stable,
}

export const activityMappingCreditReview = {
  Downgrade: Activity.Downgrade,
  Upgrade: Activity.Upgrade,
  FirstScore: Activity.FirstScore,
};

export const activityMappingCreditRating = {
  DOWN: Activity.Downgrade,
  UP: Activity.Upgrade,
  FIRST_SCORE: Activity.FirstScore,
};

export const activityMappingGeneric = {
  downgrade: Activity.Downgrade,
  upgrade: Activity.Upgrade,
  new: Activity.FirstScore,
};

export const activityMappingPortfolioItems = {
  NO_ACTIVITY: Activity.None,
  NEW: Activity.FirstScore,
  UPGRADE: Activity.Upgrade,
  DOWNGRADE: Activity.Downgrade,
  AFFIRMATION: Activity.Affirmation,
  STABLE: Activity.Stable,
};

export const activityLabels: Record<Activity, string> = {
  [Activity.Downgrade]: 'Downgrade',
  [Activity.Upgrade]: 'Upgrade',
  [Activity.FirstScore]: 'New',
  [Activity.Affirmation]: 'Affirmation',
  [Activity.Stable]: 'Stable',
  [Activity.None]: '',
};
